import { defineComponent } from 'vue';
import SiteFooter from '@/components/Footer.vue';
import Navbar from '@/components/Navbar.vue';
export default defineComponent({
    name: 'App',
    components: { Navbar, SiteFooter },
});
